import { BASE_URL } from "config";
import { getHeaders } from "utils";
import * as baseApi from "./_base";

export const endpoints = {
    list: `${BASE_URL}/api/v1/site/`,
    detail: (id) => `${BASE_URL}/api/v1/site/${id}/`,
    generate: (id) => `${BASE_URL}/api/v1/site/${id}/generate/`,
};

export const siteLoad = (token, payload) => baseApi.ListLoad(endpoints.list, token, payload);
export const siteDetailLoad = (token, { id }) => baseApi.DetailLoad(endpoints.detail, token, { id });
export const siteUpdate = (token, data) => baseApi.Update(endpoints.list, endpoints.detail, token, data);
export const siteDelete = (token, { id }) => baseApi.Delete(endpoints.detail, token, { id });

export const siteGenerate = (token, { id }) => baseApi.Load(
    'post', endpoints.generate(id), {},
    {
        headers: getHeaders(token)
    }
);
